import axios from 'axios';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";

export const setAuthToken = (token:String) => {
   if (token) {
       axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
   }
   else {
        delete axios.defaults.headers.common["Authorization"];
   }
}
    /*
    // Add a 401 response interceptor
    axios.interceptors.response.use(function (response) {
        return response;
      }, function (error) {

        if("ERR_NETWORK" === error.code) {
            //Cookies.set('jwt','');    
            
            toast.error(error.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
        }
        
        if (401 === error.response?.status) {
            Cookies.set('jwt','');
            const win: Window = window;
            toast.error("Session expired, please login again");
            win.location = '/login';
        } else {
            return Promise.reject(error);
        }
    });*/
  

    axios.interceptors.response.use(
        response => response,
        async error => {
            const originalRequest = error.config;
    
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    const refreshResponse = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ '/refresh', null, {
                        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                    });
                    const newToken = refreshResponse.data.access_token;
    
                    localStorage.setItem('token', newToken);
                    setAuthToken(newToken);
                    Cookies.set('jwt',newToken);
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;
                    return axios(originalRequest);
                } catch (err) {
                    localStorage.removeItem('token');
                    Cookies.set('jwt','');
                    toast.error("Session expired, please login again");
                    window.location.href = '/login';
                }
            }
            return Promise.reject(error);
        }
    );